var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPctStep02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 110,
    viewBox: "0 0 150 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_1428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5673 15.8058H15.2479C14.3086 15.8058 13.5471 16.5672 13.5471 17.5066V67.9279C13.5471 68.8672 14.3086 69.6287 15.2479 69.6287H63.5673C64.5066 69.6287 65.2681 68.8672 65.2681 67.9279V17.5066C65.2681 16.5672 64.5066 15.8058 63.5673 15.8058Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0755 12.2386H10.0148C9.58606 12.2386 9.23853 12.5862 9.23853 13.0149V64.1689C9.23853 64.5976 9.58606 64.9452 10.0148 64.9452H59.0755C59.5042 64.9452 59.8518 64.5976 59.8518 64.1689V13.0149C59.8518 12.5862 59.5042 12.2386 59.0755 12.2386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0755 66.1748H10.0148C8.90708 66.1748 8 65.2765 8 64.1601V13.0148C8 11.8984 8.89836 11 10.0148 11H59.0755C60.1832 11 61.0903 11.8984 61.0903 13.0148V64.1688C61.0903 65.2765 60.1919 66.1835 59.0755 66.1835V66.1748ZM10.477 63.7065H58.6133V13.477H10.477V63.7065Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1705 20.2103H18.3268V26.054H24.1705V20.2103Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1704 26.4988H18.3267C18.0825 26.4988 17.8906 26.2982 17.8906 26.0627V20.2191C17.8906 19.9748 18.0912 19.783 18.3267 19.783H24.1704C24.4146 19.783 24.6065 19.9836 24.6065 20.2191V26.0627C24.6065 26.3069 24.4059 26.4988 24.1704 26.4988ZM18.7628 25.6179H23.7343V20.6464H18.7628V25.6179Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4757 22.2599H28.8453V24.013H50.4757V22.2599Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1705 30.5283H18.3268V36.372H24.1705V30.5283Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1704 36.8082H18.3267C18.0825 36.8082 17.8906 36.6076 17.8906 36.3721V30.5284C17.8906 30.2842 18.0912 30.0923 18.3267 30.0923H24.1704C24.4146 30.0923 24.6065 30.2929 24.6065 30.5284V36.3721C24.6065 36.6163 24.4059 36.8082 24.1704 36.8082ZM18.7628 35.9272H23.7343V30.9558H18.7628V35.9272Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4757 32.5692H28.8453V34.3223H50.4757V32.5692Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1705 40.8376H18.3268V46.6813H24.1705V40.8376Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1704 47.1261H18.3267C18.0825 47.1261 17.8906 46.9255 17.8906 46.6901V40.8464C17.8906 40.6022 18.0912 40.4103 18.3267 40.4103H24.1704C24.4146 40.4103 24.6065 40.6109 24.6065 40.8464V46.6901C24.6065 46.9343 24.4059 47.1261 24.1704 47.1261ZM18.7628 46.2452H23.7343V41.2737H18.7628V46.2452Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4757 42.8872H28.8453V44.6403H50.4757V42.8872Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1705 51.1558H18.3268V56.9994H24.1705V51.1558Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1704 57.4355H18.3267C18.0825 57.4355 17.8906 57.2349 17.8906 56.9994V51.1557C17.8906 50.9115 18.0912 50.7196 18.3267 50.7196H24.1704C24.4146 50.7196 24.6065 50.9202 24.6065 51.1557V56.9994C24.6065 57.2436 24.4059 57.4355 24.1704 57.4355ZM18.7628 56.5546H23.7343V51.5831H18.7628V56.5546Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4757 53.2053H28.8453V54.9584H50.4757V53.2053Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1845 31.6099C19.6525 31.6099 19.1379 31.418 18.7367 31.0691L11.7766 25.0423C11.3318 24.6585 11.0614 24.109 11.0178 23.5247C10.9742 22.9403 11.1661 22.3559 11.5498 21.9111L13.9658 19.1201C14.7682 18.1956 16.1725 18.0996 17.0883 18.8933L19.513 20.9953L24.6153 14.9248C24.9903 14.4713 25.5311 14.1922 26.1242 14.1399C26.7085 14.0875 27.2929 14.2707 27.7377 14.6545L30.5636 17.0268C31.4969 17.8118 31.619 19.2073 30.834 20.1493L21.8679 30.8162C21.4841 31.2697 20.9346 31.5488 20.3503 31.6011C20.2892 31.6011 20.2369 31.6011 20.1758 31.6011L20.1845 31.6099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1845 29.3945L13.2332 23.359L15.6491 20.568L19.7746 24.1439L26.3247 16.3466L29.1506 18.7189L20.1845 29.3945Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7425 45.1377H47.4231C46.4838 45.1377 45.7223 45.8992 45.7223 46.8385V97.2598C45.7223 98.1992 46.4838 98.9606 47.4231 98.9606H95.7425C96.6818 98.9606 97.4432 98.1992 97.4432 97.2598V46.8385C97.4432 45.8992 96.6818 45.1377 95.7425 45.1377Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2507 41.5703H42.1899C41.7612 41.5703 41.4137 41.9179 41.4137 42.3466V93.5006C41.4137 93.9293 41.7612 94.2768 42.1899 94.2768H91.2507C91.6794 94.2768 92.0269 93.9293 92.0269 93.5006V42.3466C92.0269 41.9179 91.6794 41.5703 91.2507 41.5703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2507 95.5153H42.1899C41.0823 95.5153 40.1752 94.617 40.1752 93.5006V42.3465C40.1752 41.2389 41.0735 40.3318 42.1899 40.3318H91.2507C92.3584 40.3318 93.2655 41.2301 93.2655 42.3465V93.5006C93.2655 94.6082 92.3671 95.5153 91.2507 95.5153ZM42.6522 93.0383H90.7884V42.8088H42.6522V93.0383Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3455 49.5421H50.5018V55.3858H56.3455V49.5421Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3456 55.8305H50.5019C50.2577 55.8305 50.0658 55.6299 50.0658 55.3944V49.5507C50.0658 49.3065 50.2664 49.1146 50.5019 49.1146H56.3456C56.5898 49.1146 56.7817 49.3152 56.7817 49.5507V55.3944C56.7817 55.6386 56.5811 55.8305 56.3456 55.8305ZM50.938 54.9496H55.9095V49.9781H50.938V54.9496Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6508 51.5917H61.0205V53.3448H82.6508V51.5917Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3455 59.8602H50.5018V65.7039H56.3455V59.8602Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3456 66.1486H50.5019C50.2577 66.1486 50.0658 65.948 50.0658 65.7125V59.8688C50.0658 59.6246 50.2664 59.4327 50.5019 59.4327H56.3456C56.5898 59.4327 56.7817 59.6333 56.7817 59.8688V65.7125C56.7817 65.9567 56.5811 66.1486 56.3456 66.1486ZM50.938 65.2677H55.9095V60.2962H50.938V65.2677Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6508 61.9099H61.0205V63.663H82.6508V61.9099Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3455 70.1781H50.5018V76.0218H56.3455V70.1781Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3456 76.4579H50.5019C50.2577 76.4579 50.0658 76.2573 50.0658 76.0218V70.1782C50.0658 69.9339 50.2664 69.7421 50.5019 69.7421H56.3456C56.5898 69.7421 56.7817 69.9427 56.7817 70.1782V76.0218C56.7817 76.2661 56.5811 76.4579 56.3456 76.4579ZM50.938 75.577H55.9095V70.6055H50.938V75.577Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6508 72.2191H61.0205V73.9722H82.6508V72.2191Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3455 80.4875H50.5018V86.3312H56.3455V80.4875Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3456 86.7761H50.5019C50.2577 86.7761 50.0658 86.5754 50.0658 86.34V80.4963C50.0658 80.2521 50.2664 80.0602 50.5019 80.0602H56.3456C56.5898 80.0602 56.7817 80.2608 56.7817 80.4963V86.34C56.7817 86.5842 56.5811 86.7761 56.3456 86.7761ZM50.938 85.8951H55.9095V80.9236H50.938V85.8951Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6508 82.5371H61.0205V84.2902H82.6508V82.5371Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3597 60.9418C51.8277 60.9418 51.3131 60.7499 50.9119 60.401L43.9518 54.3742C43.507 53.9904 43.2366 53.4409 43.193 52.8566C43.1494 52.2722 43.3413 51.6878 43.725 51.243L46.141 48.452C46.9434 47.5275 48.3389 47.4315 49.2634 48.2252L51.6881 50.3272L56.7904 44.2568C57.1655 43.8032 57.7062 43.5241 58.2993 43.4718C58.8837 43.4195 59.4681 43.6026 59.9129 43.9864L62.7388 46.3587C63.672 47.1437 63.7941 48.5392 63.0092 49.4812L54.043 60.1481C53.6593 60.6016 53.1098 60.8807 52.5254 60.9331C52.4644 60.9331 52.412 60.9331 52.351 60.9331L52.3597 60.9418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3597 58.7262L45.4083 52.6994L47.8243 49.9084L51.9498 53.4756L58.4999 45.6782L61.3258 48.0593L52.3597 58.7262Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.166 22.4258H92.8468C91.9075 22.4258 91.146 23.1872 91.146 24.1266V74.5479C91.146 75.4872 91.9075 76.2487 92.8468 76.2487H141.166C142.105 76.2487 142.867 75.4872 142.867 74.5479V24.1266C142.867 23.1872 142.105 22.4258 141.166 22.4258Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.674 18.8584H87.6137C87.1849 18.8584 86.8374 19.2059 86.8374 19.6346V70.7887C86.8374 71.2174 87.1849 71.5649 87.6137 71.5649H136.674C137.103 71.5649 137.451 71.2174 137.451 70.7887V19.6346C137.451 19.2059 137.103 18.8584 136.674 18.8584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.674 72.8035H87.6136C86.506 72.8035 85.5989 71.9052 85.5989 70.7888V19.6348C85.5989 18.5271 86.4972 17.62 87.6136 17.62H136.674C137.782 17.62 138.689 18.5184 138.689 19.6348V70.7888C138.689 71.8965 137.791 72.8035 136.674 72.8035ZM88.0759 70.3265H136.212V20.097H88.0759V70.3265Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.761 26.8302H95.9169V32.6739H101.761V26.8302Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.769 33.1187H95.9256C95.6814 33.1187 95.4895 32.9181 95.4895 32.6826V26.8389C95.4895 26.5947 95.6901 26.4028 95.9256 26.4028H101.769C102.013 26.4028 102.205 26.6034 102.205 26.8389V32.6826C102.205 32.9268 102.005 33.1187 101.769 33.1187ZM96.3617 32.2378H101.333V27.2663H96.3617V32.2378Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.075 28.8798H106.444V30.6329H128.075V28.8798Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.761 37.1483H95.9169V42.992H101.761V37.1483Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.769 43.4368H95.9256C95.6814 43.4368 95.4895 43.2362 95.4895 43.0007V37.157C95.4895 36.9128 95.6901 36.7209 95.9256 36.7209H101.769C102.013 36.7209 102.205 36.9216 102.205 37.157V43.0007C102.205 43.2449 102.005 43.4368 101.769 43.4368ZM96.3617 42.5559H101.333V37.5844H96.3617V42.5559Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.075 39.1979H106.444V40.951H128.075V39.1979Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.761 47.4662H95.9169V53.3099H101.761V47.4662Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.769 53.7461H95.9256C95.6814 53.7461 95.4895 53.5455 95.4895 53.31V47.4664C95.4895 47.2222 95.6901 47.0303 95.9256 47.0303H101.769C102.013 47.0303 102.205 47.2309 102.205 47.4664V53.31C102.205 53.5543 102.005 53.7461 101.769 53.7461ZM96.3617 52.8652H101.333V47.8937H96.3617V52.8652Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.075 49.5072H106.444V51.2603H128.075V49.5072Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.761 57.7756H95.9169V63.6193H101.761V57.7756Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.769 64.0641H95.9256C95.6814 64.0641 95.4895 63.8635 95.4895 63.628V57.7844C95.4895 57.5401 95.6901 57.3483 95.9256 57.3483H101.769C102.013 57.3483 102.205 57.5489 102.205 57.7844V63.628C102.205 63.8723 102.005 64.0641 101.769 64.0641ZM96.3617 63.1832H101.333V58.2117H96.3617V63.1832Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.075 59.8252H106.444V61.5783H128.075V59.8252Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7834 38.2297C97.2514 38.2297 96.7368 38.0379 96.3356 37.689L89.3755 31.6621C88.9307 31.2784 88.6603 30.7289 88.6167 30.1445C88.5731 29.5602 88.765 28.9758 89.1487 28.531L91.5647 25.74C92.3671 24.8154 93.7626 24.7195 94.6871 25.5132L97.1118 27.6152L102.214 21.5447C102.589 21.0912 103.13 20.8121 103.723 20.7597C104.307 20.7074 104.892 20.8906 105.337 21.2743L108.162 23.6467C109.096 24.4317 109.218 25.8272 108.433 26.7691L99.4667 37.436C99.083 37.8896 98.5335 38.1687 97.9491 38.221C97.8881 38.221 97.8357 38.221 97.7747 38.221L97.7834 38.2297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7835 36.0144L90.8234 29.9876L93.2481 27.1966L97.3648 30.7638L103.915 22.9664L106.75 25.3475L97.7835 36.0144Z",
    fill: "#50A1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_1428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPctStep02);
export default __webpack_public_path__ + "static/media/pct_step02.969bf036b6e38f8f08ddf9c4f995e8f3.svg";
export { ForwardRef as ReactComponent };